var map = {
	"./1/marquee.jpg": "v1os"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ruc7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3 ^\.\/.*\/marquee\.jpg$
// module id = Ruc7
// module chunks = 39